export interface ITokenBody {
    exp: number;
    iat: number;
    iss: string;
    jti: string;
    memberId: number;
    rat: number;
    role: string;
}

export interface ITokenService {
    getToken(): ng.IPromise<IToken>;
    getAuthHeader(): ng.IPromise<string>;
    getTokenHeader(): ng.IPromise<object>;
    getTokenBody(): ng.IPromise<ITokenBody>;
}

export interface IToken {
    token: string;
    member: {
        id: string;
        email: string;
        firstName: string;
        surname: string;
    }
}

export class TokenService implements ITokenService {
    public static $inject = ['$http', '$rootScope'];

    constructor(protected $http: ng.IHttpService, protected $rootScope: ng.IRootScopeService) {
        this.$rootScope.$on('loginService:success', (ev, currentMember: number, previousMember: number) => {
            if (currentMember != previousMember) {
                // this.resetToken();
                this.jwt = null;
            }
        })
    }

    protected requestToken(): ng.IPromise<IToken> {
        return this.$http.get('/GeoFeature/token').then((resp) => {
            return resp.data;
        }, () => {
            return null;
        });
    }

    protected jwt: ng.IPromise<IToken>;

    public getToken() : ng.IPromise<IToken> {
        this.jwt = this.jwt || this.requestToken();

        return this.jwt;
    }

    public getTokenHeader(): ng.IPromise<object> {
        return this.getToken().then(token => {
            const t = token.token;
            const header = t.split('.')[0];
            try {
                return header ? JSON.parse(atob(header)) : null;
            } catch (e) {
                return null;
            }
        });
    }

    public getTokenBody(): ng.IPromise<ITokenBody> {
        return this.getToken().then(token => {
            const t = token.token;
            const tokenBody = t.split('.')[1];
            try {
                return tokenBody ? JSON.parse(atob(tokenBody)) : null;
            } catch (e) {
                return null;
            }
        });
    }

    public getAuthHeader(): ng.IPromise<string> {
        return this.getToken().then((jwt) => {
            if (jwt) {
                return `Bearer ${jwt.token}`;
            }
            return null;
        });
    }

    public resetToken(): ng.IPromise<IToken> {
        this.jwt = this.requestToken();
        return this.requestToken();
    }
}